import { usePrestudyContext } from "../../context/Prestudy/PrestudyContextProvider";
import { Text, VStack } from "@chakra-ui/layout";
import { SPACING } from "../../constants/Constants";
import { Tag, TagCloseButton } from "@chakra-ui/tag";
import { getRandomColor } from "../../utility-functions/ColorUtils";

export default function ParticipantCard({ participantName }: { participantName: string }) {
    const { removeParticipant } = usePrestudyContext().participantContext;
    return (
        <Tag colorScheme={getRandomColor()}>
            <VStack mx={SPACING / 4}>
                <Text>{participantName}</Text>
            </VStack>
            <TagCloseButton onClick={() => removeParticipant(participantName)} fontSize={"larger"} />
        </Tag>
    );
}